import request from '../utils/request'
import { SERVER_URL } from '../utils/constants'

export default class AboutService {
  static async getAboutData() {
    const response = await request(SERVER_URL + 'aboutus')
    return response
  }

  static async getTermsAndCondition() {
    const response = await request(SERVER_URL + 'terms-conditions')
    return response
  }
  static async getPrivacyPolicy() {
    const response = await request(SERVER_URL + 'privacy-policy')
    return response
  }

  static async getContactInfo() {
    const response = await request(SERVER_URL + 'contact-info')
    return response
  }
}
